export default {
  nav: {
    coreLogic: 'ตรรกะหลัก',
    profitMechanism: 'กลไกกำไร',
    profitFlywheel: 'กงล้อกำไร',
    sysArch: 'สถาปัตยกรรมระบบ',
    tradingExample: 'กรณีการซื้อขาย',
    cta: 'เริ่มต้น',
    language: 'ภาษา',
  },
  hero: {
    badge: 'Poly Ai Claw Intelligence Engine',
    title1: 'จากการทำนายสู่',
    title2: 'การอาร์บิทราจความน่าจะเป็น',
    desc: 'Polywin ยกระดับตลาดการทำนายเป็นเครื่องยนต์อาร์บิทราจเชิงระบบผ่าน Poly Ai Claw Intelligence Engine',
    ctaPrimary: 'เปิดใช้ Poly Ai Claw Engine',
    ctaSecondary: 'ดูตัวอย่าง',
    statsEvents: 'เหตุการณ์ที่ติดตาม',
    statsSuccessRate: 'อัตราความสำเร็จการดำเนินการ',
    statsExecTime: 'เวลาดำเนินการ',
    cardTitle: 'การวิเคราะห์ความเบี่ยงเบนความน่าจะเป็น',
    cardBadge: 'โซนข้อได้เปรียบ EV',
    cardMarketProb: 'ความน่าจะเป็นตลาด',
    cardAiProb: 'ความน่าจะเป็น AI',
    cardMarketImplied: 'ความน่าจะเป็นแฝงของตลาด',
    cardAiTrue: 'ความน่าจะเป็นจริงของ AI',
    cardProbDiff: 'ข้อได้เปรียบความน่าจะเป็น',
  },
  coreLogic: {
    badge: 'ระบบการตัดสินใจ PolyAi-Claw',
    title1: 'จากการรวมข้อมูลถึงผลตอบแทนทบต้น —',
    title2: 'วงจรอัตโนมัติสมบูรณ์',
    desc: 'ข้อมูลหลายแหล่ง → AI → ความเบี่ยงเบน → ดำเนินการอัตโนมัติ → ผลตอบแทนทบต้น',
    step0_title: 'ชั้นข้อมูล',
    step0_sub: 'การรวมหลายแหล่ง',
    step0_i0: 'เหตุการณ์การเมือง',
    step0_i1: 'เศรษฐกิจมหภาค',
    step0_i2: 'ความรู้สึกสังคม',
    step0_i3: 'ข้อมูลสมุดคำสั่ง',
    step1_title: 'AI Modeling',
    step1_sub: 'การอัปเดตความน่าจะเป็นเบย์',
    step1_i0: 'ข้อมูลเรียลไทม์',
    step1_i1: 'AI Modeling Engine',
    step1_i2: 'การคำนวณความน่าจะเป็น',
    step1_i3: 'การปรับแบบจำลอง',
    step2_title: 'การตรวจจับความเบี่ยงเบน',
    step2_sub: 'ระบุความเบี่ยงเบนความน่าจะเป็น',
    step2_i0: 'ความน่าจะเป็นแฝงตลาด',
    step2_i1: 'ความน่าจะเป็นจริง AI',
    step2_i2: 'การระบุข้อได้เปรียบ EV',
    step2_i3: 'สัญญาณเปิดสถานะ',
    step3_title: 'การดำเนินการบนเชน',
    step3_sub: 'การซื้อขายอัตโนมัติ Polygon',
    step3_i0: 'การควบคุมความเสี่ยง',
    step3_i1: 'การจัดสรรทุน',
    step3_i2: 'การชำระ USDC',
    step3_i3: 'สัญญาอัจฉริยะ',
    step4_title: 'ผลตอบแทนทบต้น',
    step4_sub: 'การลงทุนซ้ำอัตโนมัติ',
    step4_i0: 'การชำระเหตุการณ์',
    step4_i1: 'การชำระกำไร',
    step4_i2: 'การคำนวณทบต้น',
    step4_i3: 'วงจรการลงทุนซ้ำ',
    keyTitle: 'เป้าหมายหลัก',
    keyDesc: 'เป้าหมายของ PolyAi-Claw คือการค้นหาการกำหนดราคาผิดพลาดของความน่าจะเป็น (Mispricing) อย่างต่อเนื่องและดำเนินการอาร์บิทราจอย่างเป็นระบบ',
    keyHighlight: 'ค้นหาการกำหนดราคาผิดพลาดของความน่าจะเป็นและดำเนินการอาร์บิทราจอย่างเป็นระบบ',
  },
  profitMechanism: {
    badge: 'กลไกกำไรหลัก',
    title1: '3 กลไกกำไรของ',
    title2: 'PolyAi-Claw',
    desc: 'ระบบอาร์บิทราจความน่าจะเป็นที่มั่นคงผ่านการตรวจจับข้อได้เปรียบ EV การดำเนินการมิลลิวินาที และการจัดการทุน 3 ระดับ',
    m1_title: 'การตรวจจับข้อได้เปรียบ EV',
    m1_sub: 'Probability Edge Detection',
    m1_desc: 'ตรรกะหลัก: ราคาตลาด ≠ ความน่าจะเป็นจริง เมื่อ AI ตรวจพบความเบี่ยงเบน ระบบจะเข้าสู่โซน EV โดยอัตโนมัติ',
    m1_marketImplied: 'ความน่าจะเป็นแฝงตลาด',
    m1_aiTrue: 'ความน่าจะเป็นจริง AI',
    m1_probDiff: 'ข้อได้เปรียบความน่าจะเป็น',
    m1_note: 'หลักการเดียวกับอาร์บิทราจออปชั่นของกองทุน Quant',
    m2_title: 'การดำเนินการอัตโนมัติมิลลิวินาที',
    m2_sub: 'Millisecond Execution',
    m2_desc: 'กรอบการดำเนินการอัตโนมัติเต็มรูปแบบเพื่อให้แน่ใจว่าโอกาสอาร์บิทราจไม่สูญหาย',
    m2_i0_title: 'ความเร็วดำเนินการมิลลิวินาที',
    m2_i0_sub: 'เฉลี่ย <200ms',
    m2_i1_title: 'โปร่งใสบนเชนสมบูรณ์',
    m2_i1_sub: 'Polygon PoS',
    m2_i2_title: 'ไม่มีการแทรกแซงของมนุษย์',
    m2_i2_sub: 'สัญญาอัจฉริยะชำระอัตโนมัติ',
    m2_network_label: 'เครือข่ายดำเนินการ',
    m2_network_val: 'Polygon + USDC',
    m3_title: 'การจัดการทุน 3 ระดับ',
    m3_sub: 'Three-Tier Risk Control',
    m3_desc: 'หลีกเลี่ยงเลเวอเรจสูงและความเสี่ยงจุดเดียวในการเก็งกำไรแบบดั้งเดิม',
    m3_i0_title: 'กองทุนผลตอบแทนมั่นคง',
    m3_i0_desc: 'อาร์บิทราจความน่าจะเป็นความแน่นอนสูง ความเสี่ยงต่ำที่สุด',
    m3_i1_title: 'กองทุนอาร์บิทราจความผันผวน',
    m3_i1_desc: 'ดักจับความผันผวนของตลาด ยืดหยุ่นผลตอบแทนสูง',
    m3_i2_title: 'กองทุนป้องกันความเสี่ยง',
    m3_i2_desc: 'ป้องกันเหตุการณ์ที่สัมพันธ์ต่ำ ลดความเสี่ยงเชิงระบบ',
    m3_risk: 'ความเสี่ยงต่อเหตุการณ์ < 5%',
    formula_title: 'สูตรอาร์บิทราจความน่าจะเป็น',
    formula_marketPrice: 'ราคาตลาด',
    formula_aiTrue: 'ความน่าจะเป็นจริง AI',
    formula_trigger: 'เปิดสถานะ',
    formula_arbitrage: 'อาร์บิทราจ',
    formula_hiddenPct: 'แฝง 60%',
    formula_evEdge: 'ข้อได้เปรียบ EV +12%',
    formula_autoExec: 'ดำเนินการอัตโนมัติ',
  },
  fundManagement: {
    riskTitle: 'หลักการควบคุมความเสี่ยงหลัก',
    riskDesc: 'ระบบตั้งค่าการเปิดรับความเสี่ยงสูงสุดต่อเหตุการณ์ < 5%',
    riskHighlight: 'การเปิดรับความเสี่ยงสูงสุดต่อเหตุการณ์ < 5%',
    stat_maxSingle: 'การลงทุนสูงสุดต่อครั้ง',
    stat_maxSingleVal: '5%',
    stat_diversify: 'การกระจายทุน',
    stat_diversifyVal: '20+ เหตุการณ์',
    stat_stopLoss: 'กลไกหยุดขาดทุน',
    stat_stopLossVal: 'เปิดใช้อัตโนมัติ',
    vizTitle: 'การแสดงภาพข้อมูลการควบคุมความเสี่ยง',
    viz_exposure: 'การควบคุมการเปิดรับ',
    viz_diversify: 'การกระจายทุน',
    viz_correlation: 'ความสัมพันธ์เหตุการณ์',
    viz_stability: 'ความมั่นคงของกลยุทธ์',
  },
  techAdvantage: {
    badge: 'ข้อได้เปรียบหลัก',
    title1: 'ทำไม PolyAi-Claw',
    title2: 'ดีกว่าตลาดการทำนายแบบดั้งเดิม?',
    dim_decision: 'พื้นฐานการตัดสินใจ',
    dim_monitor: 'ความถี่การติดตาม',
    dim_execute: 'วิธีการดำเนินการ',
    dim_model: 'โมเดลการรับรู้',
    dim_risk: 'การควบคุมความเสี่ยง',
    human_decision: 'ขับเคลื่อนด้วยอารมณ์',
    human_monitor: 'ความถี่ต่ำ',
    human_execute: 'สั่งซื้อด้วยตนเอง',
    human_model: 'อัตวิสัย',
    human_risk: 'ตามประสบการณ์',
    ai_decision: 'ขับเคลื่อนด้วยข้อมูล',
    ai_monitor: 'ความถี่สูง',
    ai_execute: 'ดำเนินการอัตโนมัติ',
    ai_model: 'โมเดลความน่าจะเป็น',
    ai_risk: 'จัดการโดยอัลกอริทึม',
    humanPredict: 'การทำนายของมนุษย์',
    adv1_title: 'ข้อมูล vs อารมณ์',
    adv1_desc: 'PolyAi-Claw สร้างโมเดลจากข้อมูลหลายแหล่ง รวมถึงเหตุการณ์การเมือง เศรษฐกิจมหภาค ความรู้สึกสังคม',
    adv1_label: 'จำนวนแหล่งข้อมูล',
    adv2_title: 'ความถี่สูง vs ต่ำ',
    adv2_desc: 'ระบบติดตาม 24/7 ไม่หยุด ระบุโอกาสความเบี่ยงเบนความน่าจะเป็นแบบเรียลไทม์',
    adv2_label: 'ความถี่การติดตาม',
    adv3_title: 'อัตโนมัติ vs ด้วยตนเอง',
    adv3_desc: 'ดำเนินการมิลลิวินาทีผ่านสัญญาอัจฉริยะบนเชน Polygon ไม่มีการแทรกแซง',
    adv3_label: 'ความเร็วดำเนินการ',
    adv4_title: 'อัลกอริทึม vs ประสบการณ์',
    adv4_desc: 'ระบบจัดการทุน 3 ระดับควบคุมการเปิดรับต่อเหตุการณ์ต่ำกว่า 5%',
    adv4_label: 'การควบคุมความเสี่ยง',
    conclusion_title: 'จากตลาดการทำนายสู่ Poly Ai Claw Intelligence Engine',
    conclusion_desc1: 'นี่ทำให้ PolyWin อัพเกรดจาก Prediction Market ธรรมดาสู่',
    conclusion_brand: 'Poly Ai Claw Intelligence Engine',
    conclusion_desc2: 'ระบบทำนายเชิงปริมาณ Poly Ai Claw',
  },
  productNarrative: {
    badge: 'การวางตำแหน่งผลิตภัณฑ์',
    title: 'ตัวตนที่แท้จริงของ PolyWin',
    desc: 'PolyWin ไม่ใช่แค่ตลาดการทำนาย แต่เป็นระบบที่รวม AI ตลาดการทำนาย OpenClaw และการซื้อขายเชิงปริมาณ',
    item0_title: 'ระบบอาร์บิทราจความน่าจะเป็น',
    item0_sub: 'ดักจับการกำหนดราคาผิดอย่างต่อเนื่อง',
    item1_title: 'โมเดลการดำเนินการที่มีวินัย',
    item1_sub: 'อัตโนมัติ ไม่มีการแทรกแซงอารมณ์',
    item2_title: 'AI Risk Management Engine',
    item2_sub: 'การควบคุมความเสี่ยงอัจฉริยะ',
    visual_title: '3 การแสดงภาพ',
    vis0_title: '① แผนภูมิความเบี่ยงเบนเส้นโค้งความน่าจะเป็น',
    vis0_desc: 'แสดงเส้นโค้งความน่าจะเป็น AI vs เส้นโค้งราคาตลาด',
    vis0_ai: 'ความน่าจะเป็น AI',
    vis0_market: 'ราคาตลาด',
    vis0_diff: 'ความแตกต่าง',
    vis1_title: '② แผนภูมิเรดาร์ควบคุมความเสี่ยง',
    vis1_desc: 'แสดงการเปิดรับความเสี่ยง การกระจายทุน ความสัมพันธ์เหตุการณ์ ความมั่นคง',
    vis1_exposure: 'การเปิดรับความเสี่ยง',
    vis1_diversify: 'การกระจายทุน',
    vis1_safe: 'โซนปลอดภัย',
    vis1_safeVal: 'เข้าแล้ว',
    vis2_title: '③ ผังการซื้อขายอัตโนมัติ AI',
    vis2_desc: 'เน้นวงจรสมบูรณ์: ข้อมูล → AI → ดำเนินการ → ชำระ → ทบต้น',
    vis2_exec: 'ความเร็วดำเนินการ',
    vis2_execVal: 'มิลลิวินาที',
    vis2_auto: 'อัตราการทำงานอัตโนมัติ',
    vis2_compound: 'วงจรทบต้น',
    vis2_compoundVal: 'ต่อเนื่อง',
    core_title: 'ข้อเสนอคุณค่าหลัก',
    core_desc: 'ผ่านการกำหนดราคาความน่าจะเป็นอัตโนมัติและกลไกทบต้น PolyAi-Claw ดักจับความเบี่ยงเบนราคาอย่างต่อเนื่องพร้อมควบคุมความเสี่ยง',
    core_highlight: 'การกำหนดราคาความน่าจะเป็นอัตโนมัติและกลไกทบต้น',
    core_item0: 'การกำหนดราคาอัตโนมัติ',
    core_item1: 'กลไกทบต้น',
    core_item2: 'รับประกันการควบคุมความเสี่ยง',
    core_item3: 'ดักจับความเบี่ยงเบนต่อเนื่อง',
  },
  profitFlywheel: {
    badge: 'กงล้อการเติบโตทางการเงินขับเคลื่อนด้วย AI',
    title1: 'PolyWin AI',
    title2: 'โมเดลกงล้อกำไร',
    desc: 'การเติบโตของ PolyWin ไม่พึ่งพากำไรการซื้อขายครั้งเดียว แต่อาศัยระบบทบต้นต่อเนื่องที่ขับเคลื่อนด้วย AI',
    descHighlight: 'ระบบทบต้นต่อเนื่องที่ขับเคลื่อนด้วย AI',
    aiCore: 'AI Probability Engine',
    step1_title: 'ข้อมูลทั่วโลก',
    step1_sub: 'Global Data',
    step1_desc: 'AI ติดตามข่าว การเมือง เศรษฐกิจมหภาค ความรู้สึกสังคม สมุดคำสั่งตลาดอย่างต่อเนื่อง',
    step1_tech: '50+ แหล่งข้อมูล',
    step1_techDetail: 'การหลอมรวมเรียลไทม์หลายแหล่ง',
    step2_title: 'AI Probability Modeling',
    step2_sub: 'Probability Modeling',
    step2_desc: 'ใช้โมเดลความน่าจะเป็นเบย์ โมเดลแก้ไขความรู้สึก คำนวณความน่าจะเป็นจริง',
    step2_tech: 'โมเดลเบย์',
    step2_techDetail: 'อัปเดตความน่าจะเป็นแบบไดนามิก',
    step3_title: 'ตรวจพบความเบี่ยงเบน',
    step3_sub: 'Probability Edge',
    step3_desc: 'เมื่อความน่าจะเป็นจริง AI > ความน่าจะเป็นแฝงตลาด ระบุเป็น EV Positive Opportunity',
    step3_tech: 'ความเบี่ยงเบน EV >5%',
    step3_techDetail: 'ตรวจจับ EV บวกอัตโนมัติ',
    step4_title: 'ดำเนินการซื้อขายอัตโนมัติ',
    step4_sub: 'Algorithmic Execution',
    step4_desc: 'ระบบเปิดสถานะ ป้องกัน ดำเนินการคำสั่งบนเชน Polygon โดยอัตโนมัติ',
    step4_tech: 'สัญญาอัจฉริยะ',
    step4_techDetail: '<200ms ดำเนินการมิลลิวินาที',
    step5_title: 'กำไรตลาดการทำนาย',
    step5_sub: 'Market Profit',
    step5_desc: 'เมื่อผลลัพธ์เหตุการณ์ยืนยัน ระบบได้รับผลตอบแทนอาร์บิทราจ',
    step5_tech: 'Polygon PoS',
    step5_techDetail: 'ชำระอัตโนมัติบนเชน',
    step6_title: 'การกู้คืนทุน',
    step6_sub: 'Capital Recycling',
    step6_desc: 'ระบบดึงทุนกำไรกลับสู่กองทุนโดยอัตโนมัติ',
    step6_tech: 'ชำระ USDC',
    step6_techDetail: 'Stablecoin ไม่สูญเสียอัตราแลกเปลี่ยน',
    step7_title: 'การเติบโตทบต้น',
    step7_sub: 'Compounding Capital',
    step7_desc: 'เมื่อกองทุนใหญ่ขึ้น AI สามารถเข้าตลาดใหญ่ขึ้นและมีโอกาสมากขึ้น',
    step7_tech: 'ทบต้นอัตโนมัติ',
    step7_techDetail: 'วงจรลงทุนซ้ำอัตโนมัติ',
    step8_title: 'ขนาดทุนที่ใหญ่ขึ้น',
    step8_sub: 'Larger Liquidity Pool',
    step8_desc: 'ขนาดทุนที่ใหญ่หมายถึงความสามารถซื้อขายสูงขึ้น ผลตอบแทนมั่นคงขึ้น',
    step8_tech: 'ขยายสภาพคล่อง',
    step8_techDetail: 'ยิ่งใหญ่ยิ่งได้เปรียบ',
    sum0_label: 'ชั้นข้อมูล',
    sum0_tech: '50+ กระแสหลายแหล่ง',
    sum0_detail: 'โมเดลเบย์เรียลไทม์',
    sum1_label: 'ชั้นดำเนินการ',
    sum1_tech: 'อัตโนมัติสัญญาอัจฉริยะ',
    sum1_detail: 'ชำระบนเชน Polygon PoS',
    sum2_label: 'ชั้นชำระ',
    sum2_tech: 'USDC Stablecoin',
    sum2_detail: 'ชำระไม่สูญเสีย FX',
    sum3_label: 'ชั้นทบต้น',
    sum3_tech: 'ลงทุนซ้ำอัตโนมัติ',
    sum3_detail: 'วงจรขยายขนาดบวก',
    key0_title: 'วงจรเสริมตัวเอง',
    key0_desc: 'กำไรทุกครั้งเสริมความสามารถระบบ สร้างวงจรป้อนกลับบวกสู่การเติบโตแบบเอ็กซ์โพเนนเชียล',
    key1_title: 'การเติบโตขับเคลื่อนด้วย AI',
    key1_desc: 'การเติบโตไม่พึ่งการแนะนำ แต่อาศัยความสามารถอาร์บิทราจความน่าจะเป็นของ AI',
    key2_title: 'ระบบทบต้นต่อเนื่อง',
    key2_desc: 'การดึงกำไรและลงทุนซ้ำอัตโนมัติทำให้กองทุนขยายตัวต่อเนื่อง',
    formula_title: 'สูตรการเติบโตของกงล้อ',
    f0_label: 'ข้อมูล AI',
    f1_label: 'อาร์บิทราจ',
    f2_label: 'กำไร',
    f3_label: 'ทบต้น',
    f4_label: 'ทุนมากขึ้น',
    f5_label: 'อาร์บิทราจมากขึ้น',
    connected: 'เชื่อมต่อแล้ว · สด',
  },
  sysArch: {
    badge: 'Official Architecture',
    title1: 'PolyAi-Claw AI',
    title2: 'สถาปัตยกรรมระบบ',
    desc: 'ระบบการตัดสินใจ AI สมบูรณ์ตั้งแต่การรวบรวมข้อมูลจนถึงการชำระอัตโนมัติ',
    coreBadge: 'สมอง AI หลัก',
    feat0_title: 'โครงสร้างระบบ AI สมบูรณ์',
    feat0_desc: 'ไม่ใช่กลยุทธ์ง่ายๆ แต่เป็นระบบการตัดสินใจ AI สมบูรณ์',
    feat1_title: 'การควบคุมความเสี่ยงระดับกองทุน Quant',
    feat1_desc: 'โมเดลควบคุมความเสี่ยงของกองทุน Quant มืออาชีพ',
    feat2_title: 'สถาปัตยกรรมที่ขยายได้',
    feat2_desc: 'ขยายได้สู่หลายตลาด หลายเชน หลายกลยุทธ์',
    dataflow_title: 'การไหลของข้อมูล',
  },
  tradingExample: {
    badge: 'กรณีศึกษาการซื้อขายจริง',
    title1: 'PolyAi-Claw BTC',
    title2: 'กลยุทธ์อาร์บิทราจ 5 นาที',
    desc: 'ระบบทำแค่ 3 สิ่ง: ตรวจจับความผันผวนผิดปกติ → ตัดสินใจความน่าจะเป็น 60 วินาทีสุดท้าย → ซื้อขายในโซนปลอดภัย',
    s1_title: 'BTC Market Data',
    s1_sub: 'การติดตามตลาดเรียลไทม์',
    s1_notice: 'ข้อมูลตัวอย่างเงื่อนไขการเปิดกลยุทธ์',
    s1_price: 'ราคาปัจจุบัน',
    s1_eg: 'ตัวอย่าง',
    s1_priceVol: 'ความผันผวนราคา',
    s1_vol: 'ปริมาณ',
    s1_depth: 'ความลึกสมุดคำสั่ง',
    s1_trigger: 'เปิดใช้: ความผันผวน ≥ 100 USD',
    s1_met: 'บรรลุ',
    s2_title: 'PolyAi-Claw Engine',
    s2_sub: 'การคำนวณความน่าจะเป็น AI',
    s2_marketImplied: 'ความน่าจะเป็นแฝงตลาด',
    s2_aiTrue: 'ความน่าจะเป็นจริง AI',
    s2_yes: 'YES',
    s2_probDiff: 'ข้อได้เปรียบความน่าจะเป็น',
    s2_safe: 'เข้าสู่โซนซื้อขายปลอดภัย',
    s3_title: 'Auto Trade + Profit',
    s3_sub: 'ดำเนินการอัตโนมัติและกำไร',
    s3_exec: 'ดำเนินการซื้อขาย',
    s3_buyYes: 'ซื้อ YES',
    s3_buyPrice: 'ราคาเข้า',
    s3_settlement: 'ชำระตลาดการทำนาย',
    s3_correct: 'ทำนายถูก',
    s3_profit: 'กำไรต่อการซื้อขาย',
    s3_avg: 'อัตรากำไรเฉลี่ย',
    s3_recycle: 'กำไรถูกดึงกลับสู่กองทุน',
    chart_title: 'แผนภูมิความเบี่ยงเบน AI vs ตลาด',
    chart_sub: 'ติดตามเรียลไทม์ความเบี่ยงเบน Poly Ai Claw vs ตลาด',
    chart_live: 'Live Analysis',
    chart_curDev: 'ความเบี่ยงเบนปัจจุบัน',
    chart_signal: 'สัญญาณอาร์บิทราจ',
    chart_signalVal: 'เปิดใช้',
    chart_winRate: 'พยากรณ์อัตราชนะ',
    chart_bottom_implied: 'ความน่าจะเป็นแฝงตลาด',
    chart_bottom_dev: 'โซนความเบี่ยงเบน',
    chart_bottom_dev_sub: 'โอกาสอาร์บิทราจเปิดใช้',
    chart_bottom_ai: 'ความน่าจะเป็นจริง AI',
    chart_bottom_ai_sub: 'ผลลัพธ์โมเดล Poly Ai Claw',
    chart_bottom_implied_sub: 'อิงราคาตลาด',
    chart_marketProb: 'ความน่าจะเป็นแฝงตลาด',
    chart_aiProb: 'ความน่าจะเป็นจริง AI',
    chart_deviationArea: 'โซนความเบี่ยงเบนอาร์บิทราจ',
    maxDeviation: 'ความเบี่ยงเบนสูงสุด',
    deviation: 'ความเบี่ยงเบน',
    flow_title: 'กระบวนการกลยุทธ์สมบูรณ์',
    flow0_title: 'ติดตามข้อมูล BTC',
    flow0_desc: 'ราคา/ปริมาณเรียลไทม์',
    flow1_title: 'ตรวจจับความผันผวน',
    flow1_desc: '≥ 100 USD',
    flow2_title: 'ตัวกรองเวลา',
    flow2_desc: '60 วินาทีสุดท้าย',
    flow3_title: 'ประเมินอัตราชนะ',
    flow3_desc: '≥ 60-70%',
    flow4_title: 'ดำเนินการอัตโนมัติ',
    flow4_desc: 'ซื้อ YES/NO',
    flow5_title: 'ชำระตลาด',
    flow5_desc: '1 USDC',
    flow6_title: 'ผลตอบแทนทบต้น',
    flow6_desc: '3%-10%',
    risk0_title: 'โครงสร้างควบคุมความเสี่ยง',
    risk0_i0: 'จำกัดทุนต่อเหตุการณ์ < 5%',
    risk0_i1: 'กระจายหลายเหตุการณ์',
    risk0_i2: 'หยุดขาดทุนแบบไดนามิก AI',
    risk1_title: 'กลยุทธ์เวลา',
    risk1_i0: 'ดำเนินการใน 60 วินาทีสุดท้าย',
    risk1_i1: 'หลีกเลี่ยงการซื้อขายตามอารมณ์',
    risk1_i2: 'ข้อมูลสมบูรณ์กว่า',
    risk2_title: 'ผลลัพธ์ในอดีต',
    risk2_i0: 'อัตราชนะในอดีต 80%-90%',
    risk2_i1: 'กำไรเฉลี่ย 3%-10%',
    risk2_i2: 'โมเดลอาร์บิทราจมั่นคง',
  },
  crossPlatform: {
    badge: 'อาร์บิทราจข้ามแพลตฟอร์ม',
    title1: 'PolyAi CLaw',
    title2: 'ตรรกะอาร์บิทราจตลาดการทำนายข้ามแพลตฟอร์ม',
    desc: 'เชื่อม Polymarket (Web3) และ Kalshi (ฟีแอต) ดักจับส่วนต่างราคา ทำการจับคู่อัจฉริยะ + ดำเนินการรวดเร็วยิ่ง',
    polymarket: 'Polymarket',
    kalshi: 'Kalshi',
    web3: 'Web3',
    fiat: 'ฟีแอต',
    claw: 'CLaw',
    matched: '✓ จับคู่แล้ว',
    matching: 'กำลังจับคู่...',
    sec1_badge: '01',
    sec1_accuracy: 'ความแม่นยำ 99%+',
    sec1_title: 'การจับคู่ตลาดอัจฉริยะ',
    sec1_desc: 'เหตุการณ์บนทั้งสองแพลตฟอร์มถูกผูกอัตโนมัติด้วย AI เชิงความหมาย',
    sec2_badge: '02',
    sec2_ms: 'ดำเนินการมิลลิวินาที',
    sec2_title: 'การรวมที่เป็นหนึ่งและการซื้อขายรวดเร็ว',
    sec2_desc: 'API/SDK รวมเชื่อมต่อหลายแพลตฟอร์ม การสั่งซื้อพร้อมกันมิลลิวินาที',
    connected: 'เชื่อมต่อแล้ว · สด',
    latency: 'ความหน่วงคำสั่ง',
    dailyEvents: 'เหตุการณ์ที่จับคู่รายวัน',
    successRate: 'อัตราสำเร็จการดำเนินการ',
    platforms: 'จำนวนแพลตฟอร์มที่ซิงค์',
    sec3_badge: '03',
    sec3_analytics: 'Live Analytics',
    sec3_title: 'การแสดงภาพข้อมูลอาร์บิทราจ',
    sec3_desc: 'ส่วนต่างราคาเรียลไทม์ กำไรอาร์บิทราจ และแนวโน้มการเติบโต',
    priceDeviation: 'การกระจายส่วนต่างราคา',
    volumeTitle: 'ปริมาณรายเดือน (K USDC)',
    h1Volume: 'ปริมาณสะสม H1 (USDC)',
    arbIndicators: 'ตัวชี้วัดข้อได้เปรียบอาร์บิทราจ',
    arbSuccess: 'อัตราสำเร็จสเปรดอาร์บิทราจ',
    semanticAccuracy: 'ความแม่นยำการจับคู่เชิงความหมาย',
    liquidity: 'สภาพคล่องข้ามแพลตฟอร์ม',
    hedgeCoverage: 'อัตราครอบคลุมการป้องกัน',
  },
  mathAlgo: {
    badge: 'อัลกอริทึมคณิตศาสตร์ขั้นสูงที่แม่นยำ',
    title1: 'อาร์บิทราจ Polymarket ไม่ใช่',
    title2: 'แค่ปัญหาคณิตศาสตร์ง่ายๆ',
    quote: 'ในขณะที่คุณยังคำนวณด้วยตนเอง ระบบ Quant ได้ทำสิ่งที่แตกต่างอย่างสิ้นเชิงแล้ว',
    quoteHighlight1: 'คำนวณด้วยตนเอง',
    quoteHighlight2: 'สิ่งที่แตกต่างอย่างสิ้นเชิง',
    ch0_title: 'อาร์บิทราจคืออะไร? ทำไม Polymarket ถึงมีมาก?',
    ch0_tag: 'ความไม่มีประสิทธิภาพตลาด',
    ch1_title: 'อาร์บิทราจข้ามตลาด: การพึ่งพาตรรกะ',
    ch1_tag: 'คณิตศาสตร์เชิงผสม',
    ch2_title: 'Bregman Projection: คำนวณขนาดอาร์บิทราจที่เหมาะสม',
    ch2_tag: 'การปรับให้เหมาะสมแบบนูน',
    pipeline_title: 'ระบบอาร์บิทราจ Polymarket — สถาปัตยกรรมสมบูรณ์',
    layer0: 'ชั้น 1: การรวบรวมข้อมูล',
    layer1: 'ชั้น 2: การตรวจจับการพึ่งพา',
    layer2: 'ชั้น 3: เครื่องยนต์ปรับให้เหมาะสม 3 ระดับ',
    layer3: 'ชั้น 4: การดำเนินการและการจัดการสถานะ',
    annualProfit: 'กำไรที่ถูกดึงออกรายปี: $39,688,585',
    venn_title: 'การพึ่งพาตรรกะ: P(ชนะ 5%) ⊆ P(ชนะ)',
    contradiction: 'ขัดแย้ง! P(เซตย่อย) > P(เซตแม่) → สัญญาณอาร์บิทราจเปิดใช้',
    contradiction_sub: '0.55 > 0.48 → ขัดแย้งตรรกะ → โอกาสอาร์บิทราจ',
    combinations: 'การรวมกันของตลาด',
    brutal: 'ไม่สามารถระบุทั้งหมดแบบดิบได้',
    integerConstraints: 'ข้อจำกัดการเขียนโปรแกรมจำนวนเต็ม',
    replaces: 'แทนที่การระบุ 16,384 ครั้ง',
    bregman_title: 'KL Divergence vs ระยะทางยูคลิด',
    coreData: 'ข้อมูลหลัก',
    pipeline4: 'ท่อ 4 ชั้นของระบบ',
    annualReturn: 'กำไรรายปี ≈ $39.7M',
    whyNotEnough_title: 'ทำไม "ผลรวมราคา = $1" ถึงไม่เพียงพอ?',
    singleMarket: 'ตลาดเดียว — ดูปกติ',
    crossMarket: 'ข้ามตลาด — การระเบิดแบบเอ็กซ์โพเนนเชียล',
  },
  mathProfit: {
    ch3_title: 'อัลกอริทึม Frank-Wolfe: เข้าใกล้คำตอบทีละขั้น',
    ch3_tag: 'อัลกอริทึมวนซ้ำ',
    ch3_chapter: 'บทที่ 04',
    execTitle: 'ความเสี่ยงการดำเนินการไม่เป็นอะตอม',
    profitStructure: 'โครงสร้างกำไร (เม.ย. 2024 – เม.ย. 2025)',
    totalProfit: 'รวม: $39,688,585',
    top10: 'TOP 10 ถือ 20.5%',
    kellyFormula: 'สูตรตำแหน่ง Kelly ที่ปรับปรุง',
    preTrade: '4 จุดตรวจสอบก่อนซื้อขาย',
    gate0: 'สภาพคล่องเพียงพอ?',
    gate1: 'Slippage ยอมรับได้?',
    gate2: 'ยังทำกำไรหลัง Slippage?',
    gate3: 'กำไร > $0.05 → ดำเนินการ',
  },
  safuFund: {
    badge: 'การรับประกันความปลอดภัยของสินทรัพย์',
    title: 'กองทุน SAFU Polywin',
    titleHighlight: 'กองทุน SAFU',
    desc: 'สำรองล็อคบนเชน โปร่งใส ตรวจสอบได้แบบเรียลไทม์ — สินทรัพย์ของคุณ เราปกป้อง',
    reserveLabel: 'Total Reserve · USDC · Ethereum Mainnet',
    verified: 'ยืนยันบนเชนแล้ว',
    mainDesc: 'ทีม Polywin ได้ล็อค 10 ล้าน USDC เป็นกองทุนสำรองความปลอดภัย SAFU บน Ethereum mainnet',
    mainDescHighlight: '10 ล้าน USDC',
    contractLabel: 'ที่อยู่สัญญา',
    etherscanBtn: 'ยืนยันบน Etherscan',
    stat0_label: 'ขนาดสำรอง',
    stat0_sub: 'USDC',
    stat1_label: 'อัตราล็อคบนเชน',
    stat1_sub: 'On-Chain',
    stat2_label: 'ตรวจสอบได้',
    stat2_sub: 'Real-time',
    stat3_label: 'การชดเชยในอดีต',
    stat3_val: '$0',
    stat3_sub: 'ไม่มีประวัติขาดทุน',
    f0_title: 'ล็อคบนเชน',
    f0_desc: '100% ของเงินทุนถูกล็อคในสัญญาอัจฉริยะ Ethereum mainnet',
    f1_title: 'โปร่งใสอย่างสมบูรณ์',
    f1_desc: 'ใครก็ตามสามารถดูยอดคงเหลือและประวัติธุรกรรมผ่าน Etherscan ได้แบบเรียลไทม์',
    f2_title: 'ชดเชยรวดเร็ว',
    f2_desc: 'กระบวนการชดเชยเริ่มภายใน 72 ชั่วโมงหลังยืนยันเหตุการณ์',
    f3_title: 'การตรวจสอบอิสระ',
    f3_desc: 'หน่วยงานความปลอดภัยบุคคลที่สามตรวจสอบโค้ดสัญญาอย่างสม่ำเสมอ',
  },
  cta: {
    badge: 'เริ่มต้นตอนนี้',
    title1: 'เริ่มใช้งาน',
    title2: 'Poly Ai Claw',
    title3: 'Intelligence Engine',
    desc: 'ไม่ต้องมีประสบการณ์เขียนโค้ด — ตั้งค่ากลยุทธ์ AI ใน 3 นาที',
    btn: 'เปิดใช้ AI-Claw',
    trust0: 'พาร์ทเนอร์อย่างเป็นทางการของ Polygon',
    trust1: 'ได้รับการรับรองจากหน่วยงานตรวจสอบ',
    trust2: '10,000+ ผู้ใช้ที่ใช้งานอยู่',
    trust3: '$50M+ ปริมาณสะสม',
  },
  footer: {
    tagline: 'Poly Ai Claw Intelligence Engine',
    product: 'ผลิตภัณฑ์',
    resources: 'ทรัพยากร',
    social: 'โซเชียลมีเดีย',
    link0: 'อัลกอริทึม Poly AI-Claw',
    link1: 'ระบบควบคุมความเสี่ยง',
    link2: 'Data API',
    link3: 'เอกสารสำหรับนักพัฒนา',
    res0: 'บทช่วยสอน',
    res1: 'กรณีกลยุทธ์',
    res2: 'Whitepaper',
    res3: 'ฟอรัมชุมชน',
    copyright: '© 2026 PolyWin. All rights reserved.',
    privacy: 'นโยบายความเป็นส่วนตัว',
    terms: 'ข้อกำหนดการใช้บริการ',
  },
};
